import { NgxMatNativeDateModule, } from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskModule } from 'ngx-mask';
import { MaterialModule } from '../modules/material.module';

@NgModule({
  imports: [CommonModule, BsDatepickerModule, NgxMatNativeDateModule, RouterModule, FormsModule,
     ReactiveFormsModule, MaterialModule, NgSelectModule, NgxMaskModule.forRoot(),
      AccordionModule.forRoot()],
  declarations: [],
  exports: [NgSelectModule,MatDialogModule]
})
export class AppCommonModule { }
